@if (cookiesAccepted() === false) {
<div id="coiOverlay" role="banner" style="display: flex;">
    <div role="dialog" aria-modal="true" id="coi-banner-wrapper" class="coi-banner__wrapper" dir="ltr">
        <div id="coiPage-1" class="coi-banner__page">
            <div class="coi-banner__summary">
                <div class="coi-banner__text">
                    <div class="coi-banner__headline" id="coiBannerHeadline">{{ 'COOKIES' | translation }}</div>
                    <div class="coi-banner__maintext" id="coi-banner-wrapper_label">{{ 'COOKIES_LEAD' | translation }}</div>
                </div>
            </div>
            <div class="coi-banner__page-footer" role="navigation">
                <div class="button-group">
                    <button tabindex="0" (click)="acceptCookies()" class="coi-banner__accept">{{ 'ACCEPT' | translation }}</button>
                    <div class="toggle-group">
                        <button tabindex="0" (click)="toggleDetails()" id="show_details">{{ 'SHOW_DETAILS' | translation }}</button>
                        <button tabindex="0" (click)="toggleDetails()" id="hide_details">{{ 'HIDE_DETAILS' | translation }}</button>
                    </div>
                    <div class="toggle-group">
                        <div class="coi-banner-consent-field">
                            <div class="consent-feld-name">{{ 'COOKIES_NECESSARY' | translation }}</div>
                            <div class="coi-consent-banner__switch-container" id="switch-cookie_cat_necessary">
                                <div class="coi-checkboxes">
                                    <input class="coi__checkbox" data-index="0" name="cookie_cat_necessary" id="cookie_cat_necessary" type="checkbox" checked="true" disabled="true">
                                    <div class="checkbox-toggle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="coi-consent-banner__categories-wrapper" id="coiConsentBannerCategoriesWrapper" aria-hidden="true">
                <div class="coi-consent-banner__category-container">
                    <p [innerHTML]="'COOKIES_MESSAGE' | translation"></p>
                </div>
            </div>
        </div>
    </div>
</div>
}